import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom'
import { fetchApp } from '../store/actions/appAction'
import { AppBar, Tabs, Tab, Container, Typography, TextField, Divider, Grid, Box, Avatar, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Menubar from '../components/Menubar';
import { makeStyles } from '@material-ui/core/styles';
import Google from '../components/social/Google'
import Facebook from '../components/social/Facebook'
import LinkedIn from '../components/social/LinkedIn'
import GoogleIntegration from '../components/instructions/GoogleIntegration'
import FacebookIntegration from '..//components/instructions/FacebookIntegration'
import LinkedInIntegration from '..//components/instructions/LinkedInIntegration'
import clsx from 'clsx';
import Apps from '@material-ui/icons/Apps';
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  contentSocialLogin : {
    paddingTop: "7%",
    paddingLeft: "20%",
    backgroundColor: "#e8e8e8",
    paddingRight: "5%",
    paddingBottom: "14%",

    [theme.breakpoints.down("sm")]: {
      paddingTop: "30%",
      paddingLeft: "0",
      paddingRight: "0"
    },
  },
  layoutMainCreateApp: {
    background: "white",
    padding: "2rem 2rem",
    borderRadius: "10px",
    [theme.breakpoints.up("sm")]: {
      width: "80%",
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  gridSidebarSocialLogin : {
    padding: "0 2rem 0 1rem"
  },
  small : {
    marginRight: "10px"
  },
  gridAppSocialLogin: {
    background: '#fff',
    padding: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  gridUrlSocialLogin: {
    background: '#fff',
    padding: '1rem 2.5rem',
    marginTop: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  gridAccordionSocialLogin: {
    background: '#fff',
    padding: '1rem 2.5rem',
    marginTop: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  accordionHeading: {
    fontSize: "18px",
    fontWeight: "500",
  },
  gridAPISocialLogin : {
    background: '#fff',
    marginLeft: "1rem",
    marginBottom: "3rem",
    padding: '1rem 2.5rem',
    marginTop: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
            <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

const SocialApp = () => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const {id} = useParams()
    
    useEffect(() => {
      dispatch(fetchApp(id))
    }, [dispatch, id])
    
    const app = useSelector(state => state.appReducer.app)

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
        
    return (
      <React.Fragment>
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentSocialLogin}>
          <Typography component="h1" variant="h5" align="center" color="textPrimary" spacing={4} gutterBottom>
            {app.appName}
          </Typography>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.gridAPISocialLogin}> 
            <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>API Key</p>
            <TextField
            variant="outlined"
            margin="dense"
            fullWidth
            id="apiKey"
            name="apiKey"
            value={app.apiKey || ''}
            autoFocus
            className="text-grey"
            />
            </Grid>
          </Grid>
          <Typography component="h1" variant="h5" align="center" color="textPrimary" spacing={4} gutterBottom className="mb-20">
            Social Media Login
          </Typography>
          <Grid container>
            <Grid item xs={12} md={3} className={classes.gridSidebarSocialLogin}>
              <AppBar position="static" className="sidebarSocialLogin" style={{background: '#fff'}}>
                <Tabs value={value} onChange={handleChange} orientation="vertical">
                  <Tab className="text-darkgrey" label="Google" icon={<Avatar className={classes.small} alt="google logo" src="/icon-google.png" />} {...a11yProps(0)} />
                  <Tab className="text-darkgrey" label="Facebook" icon={<Avatar className={classes.small} alt="fb logo" src="/icon-fb.png" />} {...a11yProps(1)} />
                  <Tab className="text-darkgrey" label="Linkedin" icon={<Avatar className={classes.small} alt="linkedin logo" src="/icon-linkedin.png" />} {...a11yProps(2)} />
                </Tabs>
              </AppBar>
            </Grid>
            <Grid item xs={12} md={9}>
              <Grid item xs={12} md={12} className={classes.gridAppSocialLogin}>
                <TabPanel value={value} index={0}>
                  <Google />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <Facebook />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <LinkedIn />
                </TabPanel>
              </Grid>
              {
                app?.socialApps?.length !== 0
                &&
                <Grid item xs={12} md={12} className={classes.gridUrlSocialLogin}>
                  <p className="font-size-16 reguler text-darkgrey mt-10" style={{marginBottom: "-5px"}}>Redirect URL</p>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    name="redirectUri"
                    id="redirectUri"
                    value={app.redirectUri || ''}
                    autoFocus
                  />
                </Grid>
              }
              <Grid item xs={12} md={12} className={classes.gridAccordionSocialLogin}>
                {
                  value === 0 ?
                  <GoogleIntegration />
                  :
                  value === 1 ?
                  <FacebookIntegration />
                  :
                  <LinkedInIntegration />
                }
              </Grid>
            </Grid>
          </Grid>
        </Grid>
    </React.Fragment>
  )
}

export default SocialApp
